import AppProvider from './providers/AppProvider';

export interface AppProps {
  children: JSX.Element
}
function App({ children }: AppProps): JSX.Element {
   
  return (
    <AppProvider>{children}</AppProvider>
  );
}

export default App;
